export type CountdownParts = {
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
};

export type Countdown = { ms: number } & CountdownParts;

export function parseCountdown(ms: number): CountdownParts {
  const totalSeconds = Math.floor(ms / 1000);
  const days = Math.floor(totalSeconds / 86400);
  const hours = Math.floor((totalSeconds % 86400) / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  return { days, hours, minutes, seconds };
}

export function formatCountdownTime(countdown: Countdown): string {
  const hh = String(countdown.hours).padStart(2, "0");
  const mm = String(countdown.minutes).padStart(2, "0");
  const ss = String(countdown.seconds).padStart(2, "0");

  return `${hh}:${mm}:${ss}`;
}
